// extracted by css-extract-rspack-plugin
export default {"cls1":"send_to_desk-cls1_AJk","cls2":"send_to_desk-cls2_cUD send_to_desk-cls1_AJk"};